import { Type } from '@sinclair/typebox';
export const AdminSupplierBasicSchema = Type.Object({
    id: Type.String(),
    supplierNumber: Type.String(),
    supplierName: Type.String(),
    organisationNumber: Type.String(),
});
export const AdminSupplierBasicResponseSchema = Type.Array(AdminSupplierBasicSchema);
export const AdminSupplierParamsSchema = Type.Object({
    id: Type.String(),
});
export const AdminSupplierDetailSchema = Type.Object({
    id: Type.String(),
    supplierNumber: Type.String(),
    isActive: Type.Boolean(),
    organisationNumber: Type.String(),
    name: Type.String(),
    phone: Type.Union([Type.String(), Type.Null()]),
    email: Type.Union([Type.String(), Type.Null()]),
    streetName: Type.String(),
    buildingNumber: Type.String(),
    zipCode: Type.String(),
    city: Type.String(),
    country: Type.Union([Type.String(), Type.Null()]),
    countryCode: Type.Union([Type.String(), Type.Null()]),
    bankGiro: Type.Union([Type.String(), Type.Null()]),
    postGiro: Type.Union([Type.String(), Type.Null()]),
    bic: Type.Union([Type.String(), Type.Null()]),
    iban: Type.Union([Type.String(), Type.Null()]),
    accountType: Type.Union([Type.String(), Type.Null()]),
    bankName: Type.Union([Type.String(), Type.Null()]),
    clearingNumber: Type.Union([Type.String(), Type.Null()]),
    accountNumber: Type.Union([Type.String(), Type.Null()]),
    defaultAccount: Type.Union([Type.String(), Type.Null()]),
    vatNumber: Type.String(),
    vatType: Type.Union([Type.String(), Type.Null()]),
    currency: Type.Union([Type.String(), Type.Null()]),
});
export const AdminCreateSupplierDetailSchema = Type.Object({
    name: Type.String(),
    organisationNumber: Type.String(),
    isActive: Type.Optional(Type.Boolean()),
    phone: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    email: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    streetName: Type.String(),
    buildingNumber: Type.String(),
    zipCode: Type.String(),
    city: Type.String(),
    country: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    countryCode: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    bankGiro: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    postGiro: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    bic: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    iban: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    accountType: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    bankName: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    clearingNumber: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    accountNumber: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    defaultAccount: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    vatNumber: Type.String(),
    vatType: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    currency: Type.Optional(Type.Union([Type.String(), Type.Null()])),
});
export const AdminSupplierCreateResponseSchema = Type.Object({
    id: Type.String(),
    supplierNumber: Type.String(),
});
